<template>
    <section class="user_agreement_wrp">
        <div class="public_bg_clr_wrp">
            <div class="container">
                <div class="gradient_theme_box">
                    <div class="user_agreement_header">
                        <router-link to="/" class="home_rdrtc_route_cross">
                            <i aria-hidden="true" class="fa fa-times-circle-o mbl_cross"></i>
                        </router-link>
                        <h3 class="text-center public_page_of_heading">Member AGREEMENT</h3>
                        <h4 class="text-center public_page_of_subheading">Disclaimer and the Terms and Conditions for
                            Use</h4>
                        <h4 class="text-center public_page_of_subheading">(“the Agreement” or “this Agreement”) </h4>
                    </div>
                    <div class="user_agreement_content">
                        <ol class="list">
                            <li>This Lymphomap website (<a href="https://www.lymphomap.ai/"
                                    target="_new">www.lymphomap.ai</a> and <a href="https://www.lymphomap.com/"
                                    target="_new">www.lymphomap.com</a>) (“the LYMPHOMAP”), together with
                                all content, software, artificial intelligence (“AI”) and machine learning (“ML”)
                                algorithms and models,
                                video conferencing platform, online medical space, online social network comprising
                                doctors, medical and
                                healthcare professionals, medical researchers, patients, etc. contained therein, is the
                                sole property of
                                Lymphomap. (hereinafter called “the Company” or “Lymphomap”).</li>
                            <li>A member is any individual medical doctor, oncologist, medical researcher, medical
                                student, intern,
                                resident, biochemist, biologist, pharmacist, medical physicist, healthcare professional,
                                patient,
                                hospital, medical clinic, nursing home, medical research facility or any other body
                                corporate or an
                                institution in the field of medical research and/or treatment who/that registers on
                                LYMPHOMAP by creating
                                an online account. The words “the Members” shall be used as plural for “the Member”.
                            </li>
                            <li>This agreement (“the Agreement” or “this Agreement”) is hereby made by and between the
                                Company and the
                                Member for the use of LYMPHOMAP.</li>
                            <li>As of today, LYMPHOMAP is a general purpose, comprehensive digital health ecosystem for
                                medical doctors,
                                oncologists, pathologists, radiologists, medical researchers, medical physicists,
                                nuclear medicine
                                physicians and technologists, medical imaging professionals, biochemists, biologists,
                                pharmacists,
                                healthcare workers and patients that is powered by Artificial Intelligence (“AI”) and
                                Machine Learning
                                (“ML”) and has embedded within it a Clinical AI engine (“Clinical AI”), which is a part
                                of it.</li>
                            <li>LYMPHOMAP also contains an online professional network that connects the Members, as
                                defined in clause 2
                                above, facilitating professional education and communication, including communication
                                via electronic
                                messaging and remote video conferencing, between them and dissemination and acquisition
                                of knowledge,
                                skills and information. The Member is governed by the <router-link
                                    to="/privacy-policy/">rules and
                                    policies</router-link> of the Company.</li>
                            <li>LYMPHOMAP also houses our professional teleconsulting division, for LBIL, where
                                practising doctors,
                                specialists, and clinicians will be able to assist and treat patients, non-patients and
                                caregivers with
                                expert advice. The member is governed by the rules and policies of the company. As of
                                today, Lymphomap and
                                LBIL are not supposed to be taken in as Software as a Medical Device (SaMD) as is
                                understood under section
                                502(o) of the Food, Drug and Cosmetics Act (as amended on December 31st, 2004) of the
                                United States.</li>
                            <li>If a Member decides they want to close their account, they must go through the process
                                of directly
                                contacting Lymphomap’s Admin Team. Please read the <router-link
                                    to="/privacy-policy/">Privacy
                                    Policy</router-link> to understand the guidelines on how the procedure will be
                                conducted.</li>
                            <li>As of today, the Clinical AI helps in providing very limited clinical decision support
                                to doctors and
                                researchers, and hence is not supposed to be taken as Software as a Medical Device
                                (SaMD) as is understood
                                under section 502(o) of the Food Drug & Cosmetics Act (as amended on December 31, 2004)
                                of the United
                                States.</li>
                            <li>LYMPHOMAP and/or the Clinical AI does not have approval from the Food and Drug
                                Administration (FDA) of
                                the United States of America.</li>
                            <li>LYMPHOMAP and/or the Clinical AI does not have approval or license from any other
                                government, state,
                                provincial or sovereign, agency(ies), anywhere in the world.</li>
                            <li>LYMPHOMAP’s app, otherwise known as “Our App” on our website (v.1.0), is now available.
                                A member can
                                download it from the App Store and Google Play. The app’s primary features include
                                global connectivity
                                with professionals and communication (including sharing files) with connected members. A
                                member may also
                                directly upload datasets onto the app and subsequently can download files from
                                conversations. V.1.0 of the
                                app is to solidify the connectivity aspect that is a crucial component of Lymphomap’s
                                ecosystem. As future
                                versions are launched, more features and services from the web portal, including video
                                and audio calls,
                                will be directly accessible on the app.</li>
                            <li>LYMPHOMAP is in its late alpha testing stage; however, a small and specialized group of
                                members, such as
                                oncologists, doctors with other specialties, medical researchers, medical physicists,
                                etc. have been
                                invited to register on the platform, which also contains an online professional network
                                of doctors,
                                medical and healthcare professionals and patients, and use the Clinical AI for trial,
                                testing and
                                educational purposes using real-life and/or simulated data. The beta version of
                                LYMPHOMAP is expected to
                                be released by 2nd April 2021.</li>
                            <li>Doctors, oncologists, medical researchers and/or the Member are strongly advised NOT to
                                use the Clinical
                                AI and/or any AI and/or ML algorithms and models contained in LYMPHOMAP for any
                                real-life clinical
                                decisions or clinical decision support while treating patients or making any kind of
                                diagnosis of any
                                disease. The Member should use the Clinical AI and/or any AI and/or ML algorithms and
                                models contained in
                                LYMPHOMAP ONLY for educational and training purposes and/or for running internal trials
                                or simulations for
                                an academic understanding of how AI and/or ML can be used within the context of clinical
                                decision making.
                            </li>
                            <li>The Company shall not be responsible or liable for any loss(es), financial or otherwise,
                                suffered by any
                                registered member of LYMPHOMAP, including but not limited to doctors, researchers and/or
                                hospitals,
                                clinics and laboratories with which these doctors and researchers are associated with,
                                in case of a
                                violation, voluntary or involuntary, of this Agreement or any other clause contained
                                therein, including
                                but not limited to clause no. 10 above and further the Member and/or the members of
                                LYMPHOMAP hereby
                                agrees to indemnify the Company for any loss(es), financial or otherwise, suffered by it
                                due the Members
                                violation of the terms and conditions of this Agreement or any clause contained therein.
                            </li>
                            <li>Any and all data, real-life patient data or simulated data, uploaded and/or used by the
                                Member in the
                                course of his/her/its online visit to and activity(ies) on LYMPHOMAP shall be treated by
                                the Company in
                                the strictest confidence and shall be stored by the Company for research and testing of
                                its AI/ML
                                algorithms and models. The said data shall be governed by the Company’s <router-link
                                    to="/privacy-policy/">Privacy Policy</router-link>. </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>

import { bus } from '@/main';

const $ = window.jQuery = require('jquery');
export default {
    name: 'member-agreement',
    components: {},
    props: [],
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {
        bus.$emit('showHeaderbtn', false);
    },
    methods: {
    },
    beforeCreate: function () {
        document.body.classList.add('public_page_for_wrp_img');
        document.body.classList.add('left_sidebaar_disabled_for_page');
    },
    beforeRouteLeave: function (to, from, next) {
        document.body.classList.remove('public_page_for_wrp_img');
        document.body.classList.remove('left_sidebaar_disabled_for_page');
        $(window).scrollTop(0);
        next();
    },
}
</script>


<style lang="scss" scoped>
.user_agreement_wrp {
    padding: 70px 15px 10px;
    color: #FFFDD0;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;

    .container {
        position: relative;
    }

    .gradient_theme_box {
        background: linear-gradient(-30deg, rgba(37, 44, 84, 0.6) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(38, 38, 38, 0.6) 50%, rgba(44, 44, 84, 0.6) 100%);
        padding: 30px 15px;
        border-radius: 8px;
        -webkit-box-shadow: 0 5px 10px 0 rgba(244, 242, 238, 0.2);
        box-shadow: 0 5px 10px 0 rgba(244, 242, 238, 0.1);
        border: 1px solid rgba(93, 93, 93, 0.4);
    }

    .list li {
        font-size: 18px;
        margin-top: 25px;
        line-height: 1.3;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
        text-align: justify;

        @media only screen and (max-width:1023px) {
            font-size: 16px;
        }
    }

    a {
        color: #ffd400;

        &:hover {
            color: #87cefa;
        }
    }

    a:hover {
        text-decoration: none;
    }

    .public_bg_clr_wrp {
        background: rgba(0, 0, 0, 0.92);
        padding: 20px 15px;

        @media only screen and (max-width:1023px) {
            padding: 10px 0px;
        }
    }

    .public_page_of_heading {
        font-family: 'origin_tech_demoregular';

        @media only screen and (max-width:1023px) {
            font-size: 24px;
        }
    }

    .user_agreement_content {
        ol {
            padding-left: 20px;
        }
    }

    @media only screen and (max-width:1023px) {
        .public_page_of_subheading {
            font-size: 18px;
        }
    }

    .home_rdrtc_route_cross {
        .fa {
            position: absolute;
            top: 2px;
            right: 20px;
            font-size: 35px;
            color: #e4002b;
            z-index: 100;
            cursor: pointer;

            &:hover {
                color: #ffd400;
            }

            @media only screen and (max-width:767px) {
                font-size: 25px;
            }
        }
    }
}
</style>